import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromMatchingGift from './matching-gift.reducers';

export interface MatchingGiftState {
  stateData: fromMatchingGift.State;
}

export interface State extends fromRoot.AppState {
  matchingGift: MatchingGiftState;
}

export const reducers = {
  stateData: fromMatchingGift.reducer
};

export const selectMatchingGiftState = createFeatureSelector<MatchingGiftState>('matchingGift');

export const selectMatchingGiftStateData = createSelector(selectMatchingGiftState, (state: MatchingGiftState) => state.stateData);

export const getMatchingGiftState = createSelector(selectMatchingGiftStateData, fromMatchingGift.getStateData);

export const getMatchingGiftScreenError = createSelector(selectMatchingGiftStateData, fromMatchingGift.getError);

export const getMatchingGiftScreenSuccess = createSelector(selectMatchingGiftStateData, fromMatchingGift.getSuccess);

export const getMatchingGiftScreenPending = createSelector(selectMatchingGiftStateData, fromMatchingGift.getPending);